export default __webpack_public_path__ + "static/media/photo--sm--rambo-2.2a540cfc.jpg";